<template>
  <div
    class="tw-inline-block tw-p-1 text-s tw-rounded-md tw-relative"
    :class="classes"
  >
    <button
      @click="toggle"
      :aria-expanded="isOpen"
      :aria-controls="sublineId"
      v-if="$slots.toggle"
    >
      <slot :open="isOpen" />
    </button>
    <p v-else class="tw-inline tw-text-s tipp-regular-text">
      <slot :open="isOpen" />
    </p>

    <p
      v-if="$slots.toggle"
      :id="sublineId"
      :class="{ 'tw-hidden': !isOpen }"
      class="tw-inline tw-text-s tw-font-bold"
    >
      <slot name="toggle"></slot>
    </p>

    <button
      href="#"
      v-if="$slots.toggle"
      class="tw-absolute tw-top-0 tw-right-0"
      :aria-expanded="isOpen"
      :aria-controls="sublineId"
      @click="toggle"
    >
      <span
        class="tw-icon tw-icon-hinzufuegen-bold tw-transform tw-inline-block tw-transition-transform tw-duration-300 tw-text-l"
        :class="{ 'tw-rotate-45': isOpen }"
      >
      </span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    direction: {
      type: [Object, String],
      validator: (direction) => {
        if (direction === null) {
          return true;
        }

        const allowedDirections = [
          'top-left',
          'top-right',
          'bottom-left',
          'bottom-right',
          'left'
        ];

        if (typeof direction === 'object' && direction !== null) {
          return Object.values(direction).every((direction) => {
            return allowedDirections.includes(direction);
          });
        } else {
          return allowedDirections.includes(direction);
        }
      }
    },
    emphasize: Boolean,
    info: {
      type: Boolean,
      default: false
    },
    open: Boolean,
    bold: { type: Boolean, default: () => true }
  },
  data() {
    return {
      isOpen: this.$props.open,
      sublineId:
        'subline-' +
        Math.random()
          .toString(36)
          .slice(2, 11)
    };
  },
  computed: {
    closeable() {
      return !!this.$slots.toggle;
    },
    classes() {
      const cls = [];

      // Responsive direction config
      // e.g. via
      // <tipp :direction="{'': 'top-left', 'sm': 'bottom-right'} />"
      if (typeof this.direction === 'object' && this.direction !== null) {
        Object.entries(this.direction).forEach(([breakpoint, direction]) => {
          if (breakpoint === '' || breakpoint == 'default') {
            cls.push(`tw-arrow-after-tipp-${direction}`);
          } else {
            cls.push(`${breakpoint}:tw-arrow-after-tipp-${direction}`);
          }
        });
      } else if (this.direction) {
        // simple config
        cls.push(`tw-arrow-after-tipp-${this.direction}`);
      }

      if (this.info) {
        cls.push('tw-bg-lightBlue-100', 'tw-text-grey-800', 'tw-info');
      } else if (this.emphasize) {
        cls.push('tw-bg-orange-500', 'tw-text-white', 'tw-emphasized');
      } else {
        cls.push('tw-bg-orange-100', 'tw-text-orange-800');
      }

      if (this.bold) {
        cls.push('font-bold');
      }

      if (this.closeable) {
        cls.push('tw-pr-3');
      }

      return cls;
    }
  },
  methods: {
    toggle($event) {
      // Anchors inside the tipp just work like they are supposed to
      if ($event.target.tagName === 'A') {
        return;
      }

      $event.preventDefault();
      this.isOpen = !this.isOpen;
    }
  }
};
</script>

<style lang="css" scoped>
button:focus-visible,
a:focus-visible {
  outline: 0.125rem solid #fff !important;
  outline-offset: 0.125rem;
  -webkit-box-shadow: 0 0 0 0.125rem #0060cc;
  box-shadow: 0 0 0 0.25rem #0060cc;
}

p {
  font-family: 'Aktion Mensch Bold', sans-serif;
}

.tw-emphasized:after {
  @apply tw-bg-orange-500;
}
.tw-info:after {
  @apply tw-bg-lightBlue-100;
}
.tipp-regular-text {
  font-family: 'Aktion Mensch Regular', sans-serif; /* Use a regular font */
  font-weight: normal; /* Ensure the font weight is normal */
}
</style>
